module.exports = __webpack_public_path__ + "static/media/packageCrown.2c8729d0.svg";